import { Document } from '../../../document-data/document.model';
import { List } from 'immutable';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';

export const DIALOG_TYPE = 'copy-document';

export interface ICopyDocumentDialogData {
  document?: Document;
  disableDocumentTypes?: List<DocumentTypesEnum>;
}
